/* DCL builder tracking. Reports how far shoppers get in the Factor and ENVE builders.
   Sends each event two ways:
   1. Google tag (GA4): event names start with "builder_".
   2. Shopify customer events: Shopify.analytics.publish('dcl_builder_*').
   No names, emails, or phone numbers are ever sent. Read-only: never changes builder behavior. */
(function () {
  'use strict';
  var BUILDER = /build-your-enve/.test(location.pathname) ? 'ENVE' : 'Factor';
  var reached = {};
  var d = null;
  var last = { step: null, revealed: false, submitted: false };

  function send(name, params) {
    var p = { builder: BUILDER };
    for (var k in params || {}) if (params[k] !== undefined && params[k] !== null && params[k] !== '') p[k] = params[k];
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish('dcl_builder_' + name, p);
      }
    } catch (err) {}
    try {
      if (typeof window.gtag === 'function') {
        var g = {}; for (var j in p) g[j] = p[j];
        window.gtag('event', 'builder_' + name, g);
      }
    } catch (err) {}
    try { if (window.DCL_BUILDER_DEBUG) console.log('[dcl-builder]', name, p); } catch (err) {}
  }

  function platform() { try { return d.selections && d.selections.platform; } catch (e) { return undefined; } }
  function num(fn) { try { var v = d[fn](); return typeof v === 'number' && isFinite(v) ? Math.round(v) : undefined; } catch (e) { return undefined; } }

  function check() {
    if (!d) return;
    var step, revealed, submitted;
    try { step = d.currentStep; revealed = !!d.revealed; submitted = !!d.submitted; } catch (e) { return; }

    if (step && step !== last.step) {
      last.step = step;
      if (step !== 'discipline' && !reached.__started) { reached.__started = true; send('start', { platform: platform() }); }
      if (!reached[step]) {
        reached[step] = true;
        var idx; try { idx = (d.stepFlow || []).indexOf(step); } catch (e) {}
        send('step', { step: step, step_number: idx >= 0 ? idx + 1 : undefined, platform: platform() });
        if (step === 'reveal') send('price_gate', { platform: platform(), msrp: num('buildMsrpTotal') });
      }
    }
    if (revealed && !last.revealed) {
      last.revealed = true;
      send('price_revealed', { platform: platform(), msrp: num('buildMsrpTotal'), value: num('buildDialedPrice'), currency: 'USD' });
    }
    last.revealed = revealed;
    if (submitted && !last.submitted) {
      var exit; try { var f = document.getElementById('dcl-fb-f-exit'); exit = f && f.value; } catch (e) {}
      send('submitted', { platform: platform(), exit_path: exit, value: num('buildDialedPrice'), currency: 'USD' });
    }
    last.submitted = submitted;
  }

  function wrap(name, eventName, extra) {
    try {
      var orig = d[name];
      if (typeof orig !== 'function' || orig.__dclWrapped) return;
      var w = function () {
        try { send(eventName, extra.apply(null, arguments)); } catch (e) {}
        return orig.apply(this, arguments);
      };
      w.__dclWrapped = true;
      d[name] = w;
    } catch (e) {}
  }

  function attach() {
    if (d) return true;
    var el = document.querySelector('[x-data*="uilder("]');
    if (!el || !window.Alpine || typeof Alpine.$data !== 'function') return false;
    try { d = Alpine.$data(el); } catch (e) { d = null; }
    if (!d || typeof d.nextStep !== 'function') { d = null; return false; }

    send('view', {});
    wrap('submitBuild', 'submit_click', function (kind) { return { kind: kind, platform: platform(), value: num('buildDialedPrice'), currency: 'USD' }; });
    wrap('resetBuild', 'start_over', function () { return { from_step: last.step, platform: platform() }; });

    el.addEventListener('click', function (e) {
      var a = e.target && e.target.closest && e.target.closest('a[href^="mailto:"]');
      if (a) send('email_click', { platform: platform(), step: last.step });
    }, true);

    window.addEventListener('pagehide', function () {
      if (!last.submitted) send('exit', { last_step: last.step, platform: platform(), revealed: last.revealed });
    });

    check();
    setInterval(check, 600);
    return true;
  }

  if (!attach()) {
    var tries = 0;
    document.addEventListener('alpine:initialized', attach);
    var t = setInterval(function () { if (attach() || ++tries > 60) clearInterval(t); }, 500);
  }
})();
